import styled from "styled-components";

export const Wrapper = styled.div`
margin-top: 5px;

`
export const ReportHeader = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
align-items: flex-start;
`
export const TitleContent = styled.div`
width: 100%;
display: flex;
justify-content: left;
flex-direction: column;
align-items: flex-start;
margin-bottom:20px;
h1{
color: #002E5C;
font-family: var(--ReportTitleContentH1Font-family);
font-size: 16px;
font-style: normal;
font-weight: bold;
line-height: 120.023%;
padding-bottom: 5px;
}
`
export const Date = styled.div`
    color: #81818C;
    font-size: 12px;
font-style: normal;
font-weight: 400;
padding-bottom: 5px;

span{
    font-weight: 700;   
}

`
export const FilterBy = styled.div`
    color: #81818C;
    font-size: 15px;
font-style: normal;
font-weight: 400;
padding-bottom: 5px;

span{
    font-weight: 700;   
}


`
export const AsOf = styled.div`
display: flex;
width: 156px;
span{
padding-top: 12px;
color: #4F4F4F;
text-align: right;
font-family: var(--ReportAsOfSpanFont-family);
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 120.023%; 
}
`
export const Cell = styled.span`
color: #002E5C;
font-family: var(--ReportCellFont-family);
font-size: 14px;
font-style: normal;
font-weight: bold;
line-height: 120.023%;

`
